module.exports = __webpack_public_path__ + "static/28-6b29d5ac7c1e017088a750e06c69008c.jpg";